/* istanbul ignore file */
/**
 * Copyright (c) 2021, Ouster, Inc.
 * All rights reserved.
 */

import { OusterProvider } from '@ouster/webviz-react-components';

import * as Sentry from '@sentry/react';
import { StoreProvider as EzPzProvider } from 'easy-peasy';
import { createRoot } from 'react-dom/client';
import './index.css';
import { ThemeProvider } from 'styled-components/macro';

import App from './App';
import { ousterLogoAscii } from './images/OusterLogoAscii';
import { getOusterWasmBytes } from './sdkWebPreload';
import * as serviceWorker from './serviceWorker';
import makeStore from './store';
import { darkTheme } from './Theme';
// Initialize singletons
import { registerStore as registerStoreForLogging } from './utils/log';
import { registerStoreForAuth } from './utils/requests';
import { preloadRgbAutoExposureSdk } from './utils/rgbAutoExposure';

const store = makeStore();
registerStoreForLogging(store);
registerStoreForAuth(store);

console.log(ousterLogoAscii);
console.log("We're hiring! https://ouster.com/careers/");

// SDK Web Wasm preload: fetch wasm bytes
getOusterWasmBytes().catch((e) => {
  console.error('Failed to preload Ouster SDK Web:', e);
});
preloadRgbAutoExposureSdk().catch((e) => {
  console.error('Failed to preload RGB auto exposure SDK:', e);
});

const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);

// Sentry is initialized as a side effect of importing './utils/log' above -
// see that file for the single Sentry.init() call and its config.

root.render(
  <Sentry.ErrorBoundary fallback={<div>Something went wrong.</div>}>
    <EzPzProvider store={store}>
      <ThemeProvider theme={darkTheme}>
        <OusterProvider>
          <App />
        </OusterProvider>
      </ThemeProvider>
    </EzPzProvider>
  </Sentry.ErrorBoundary>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
